// extracted by mini-css-extract-plugin
module.exports = {"carinstockDisclaimer":"carinstockDisclaimer-3vO","carinstockDisclaimerItem":"carinstockDisclaimerItem-3--","disclaimerLink":"disclaimerLink-uxQ"};